// eslint-disable-next-line no-shadow
export enum SORT_TYPE {
  asc = 'asc',
  desc = 'desc'
}
